import type { ProductVariant } from "@models/product";

/**
 * Whether a variant can be bought: active, and backed by an active in-stock vendor sku per the
 * server's isAvailable (Bug #302; absent on an older payload, read as unavailable). The chips'
 * disabled state and the page's pre-selection read this one definition, so the page never
 * pre-selects a chip it disables (BR-04).
 */
export const isVariantAvailable = (variant: ProductVariant): boolean =>
    variant.isActive && variant.isAvailable === true;
